import URLRenderer from '@/app/common/components/CellRenderers/URLRenderer';
import RankChangeRenderer from '@/app/common/components/CellRenderers/RankChangeRenderer';
import { errorMessage, successMessage } from '@/utils/toast';
import { Link } from 'react-router-dom';
import { AiOutlineZoomIn } from 'react-icons/ai';
import countSuffix from '@/helpers/countSuffix';
import { updateTransaction } from '@/app/common/components/ag-grid/updateTransaction';

export const landingUrlsColumnConfig = (
  domain_slug,
  domain,
  editLanding,
  path,
  gridRef
) => [
  {
    field: 'url',
    type: 'string',
    title: 'نشانی صفحه هدف',
    flex: 1,
    minWidth: 300,
    editable: true,
    valueSetter: params => {
      editLanding({
        landing_id: params.data.id,
        domain_slug,
        url: params.newValue
      })
        .unwrap()
        .then(res => {
          updateTransaction(res?.data, gridRef);
          successMessage('صفحه هدف با موفقیت ویرایش شد');
          return true;
        })
        .catch(err => {
          errorMessage('خطایی در ویرایش صفحه هدف وجود دارد');
          console.error(err);
          return true;
        });
    },
    searchable: true,
    cellRenderer: params => (
      <URLRenderer gapOfbuttons="ms-5" url={params.value} />
    )
  },
  {
    field: 'num_of_keywords',
    type: 'number',
    title: 'تعداد کلمات',
    width: 130,
    searchable: true,
    cellRenderer: params => {
      return params.data.num_of_keywords !== 0 ? (
        <Link
          to={`/keyword-tracker/keywords/${domain_slug}/${domain}?FByLandingUrl=[and,equals,${params.data.id}]`}
          className="d-flex align-items-center gap-1  h-100"
        >
          <AiOutlineZoomIn icon="search-plus" className="cursor-pointer fs-0" />
          <span>{params.data.num_of_keywords}</span>
        </Link>
      ) : (
        0
      );
    }
  },
  {
    field: 'total_search_volume_miztols',
    type: 'number',
    title: 'میزان جستجو',
    width: 130,
    searchable: true
  },
  {
    field: 'average_rank',
    type: 'number',
    title: 'میانگین ',
    width: 100,
    gp: 'رتبه',
    searchable: true
  },
  {
    field: 'change_average_rank',
    type: 'number',
    gp: 'رتبه',
    title: 'تغییر',
    width: 100,
    searchable: true,
    cellRenderer: params => <RankChangeRenderer change={params.value} />
  },

  {
    field: 'total_sov',
    type: 'number',
    title: 'SOV کل',
    width: 100,
    searchable: true,
    cellRenderer: ({ value }) => countSuffix(value)
  }
];
